import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'
// import TagManager from 'Components/TagManager'
import Loadable from 'Components/LoadableToImported'
import Flex from 'Components/Flex'
import SvgIcon from 'Components/SvgIcon'
import AppButton from 'Components/AppButton'
import { isBiggerThanLocality, removeAllAreaParams } from 'Utils/mapUtils'
import { buildChildParentMap, checkDirectAreaLevelExist } from './utils'
import AreaCollapsible from './components/AreaCollapsible'

import ListingCountFloatingBar from '../ListingCountFloatingBar'

import {
  _Container, _Title, _ShowAllBtn, _AllAreaCollapsible, _AreaChildrenListContainer,
  _CollapseDiscoveryAreaBtn, _ShowDiscoveryAreaContainer,
} from './styles'

const AreaBoxListSlider = Loadable({
  loader: () => import(/* wcomment: "AreaBoxListSlider" */ './components/AreaBoxListSlider'),
  loading: () => <div />,
  chunkName: 'AreaBoxListSlider',
})

// mobile view requires only collapsible
export function renderChildrenCollapsible(
  {
    area,
    lcaMapTree,
    lastSearchObj,
    calculateLcaAndSelectedAreas,
    lookups,
    setHoveredDiscoveryArea,
    childParentMap = {},
    googleAnalyticsEvent,
    filterByViewPort,
    selectAllChildrenArea,
  }) {
  if(!area || !lcaMapTree) return null
  const childAreaKey = area.children.length ? area.children[0] : null
  if(!childAreaKey) return null
  const childArea = lcaMapTree[childAreaKey]
  const hasDirectAreaLevel = checkDirectAreaLevelExist(area, childArea)
  let areaChildren = area.children
  // if there is no direct children like mississauga, should not use children to render collapsible
  if(!hasDirectAreaLevel) {
    areaChildren = [`${area.areaType}_${area.areaId}`]
  }
  return (
    areaChildren.map(child => {
      if(!lcaMapTree[child].children.length) return null
      return (
        <AreaCollapsible
          defaultActiveState={areaChildren.length < 2}
          lastSearchObj={lastSearchObj}
          currentArea={lcaMapTree[child]}
          calculateLcaAndSelectedAreas={calculateLcaAndSelectedAreas}
          lcaMapTree={lcaMapTree}
          localLookups={lookups}
          childParentMap={childParentMap}
          setHoveredDiscoveryArea={setHoveredDiscoveryArea}
          googleAnalyticsEvent={googleAnalyticsEvent}
          filterByViewPort={filterByViewPort}
          selectAllChildrenArea={selectAllChildrenArea}
          key={child}
        />
      )
    })
  )
}


class DiscoveryArea extends Component {
  constructor(props) {
    super(props)

    this.handleShowAllClick = this.handleShowAllClick.bind(this)
    this.clearAllAreas = this.clearAllAreas.bind(this)
    this.onClickListingCountButton = this.onClickListingCountButton.bind(this)
    this.setSelectedSubLocality = this.setSelectedSubLocality.bind(this)
    this.collapseOutsideClick = this.collapseOutsideClick.bind(this)
    this.discoveryAreaOpen = this.discoveryAreaOpen.bind(this)
    this.discoveryAreaClose = this.discoveryAreaClose.bind(this)

    this.state = {
      localLookups: props.lookups,
      isDiscoveryAreaCollapsed: false,
      selectedSubLocality: null,
      // To easily check if children of parent is selected on url update
      // ex Sublocality_22: [Neighbourhood_1]
      childParentMap: buildChildParentMap({
        lastSearchObj: props.lastSearchObj,
        lcaMapTree: props.lcaMapTree,
        lookups: props.lookups,
      }),
    }
  }

  static getDerivedStateFromProps(props, state) {
    if(props.lookups.classType) {
      return {
        localLookups: props.lookups,
      }
    }
    return state
  }

  shouldComponentUpdate(nextProps, nextState) {
    return (
      this.props.lcaMapTree !== nextProps.lcaMapTree ||
      this.props.userCurrentCity !== nextProps.userCurrentCity ||
      this.props.lastSearchObj !== nextProps.lastSearchObj ||
      this.props.filterByViewPort !== nextProps.filterByViewPort ||
      this.state !== nextState
    )
  }

  componentDidUpdate(prevProps, prevState) {
    if(
      this.state.localLookups !== prevState.localLookups ||
      this.props.lastSearchObj.neighbourhood_id !== prevProps.lastSearchObj.neighbourhood_id ||
      this.props.lastSearchObj.sublocality_id !== prevProps.lastSearchObj.sublocality_id ||
      this.props.lastSearchObj.locality_id !== prevProps.lastSearchObj.locality_id
    ) {
      // eslint-disable-next-line
      this.setState({
        childParentMap: buildChildParentMap({
          lastSearchObj: this.props.lastSearchObj,
          lcaMapTree: this.props.lcaMapTree,
          lookups: this.props.lookups,
          prevChildParentMap: this.state.childParentMap,
        }),
      })
    }
  }

  componentWillUnmount() {
    this.props.setDiscoveryAreaOpenState(null)
  }


  onClickListingCountButton() {
    this.props.setDiscoveryAreaOpenState(false)
  }

  setSelectedSubLocality(subLocality) {
    this.setState({
      selectedSubLocality: subLocality || null,
    })
  }
  collapseOutsideClick() {
    this.setState({
      selectedSubLocality: null,
    })
  }
  discoveryAreaOpen() {
    this.setState({ isDiscoveryAreaCollapsed: false })
  }
  discoveryAreaClose() {
    this.props.setDiscoveryAreaOpenState(false)
    this.setState({ isDiscoveryAreaCollapsed: true })
  }
  handleShowAllClick() {
    this.props.googleAnalyticsEvent({
      category: 'search',
      action: [
        'Discovery area show all click',
        this.props.isDiscoveryAreaOpen ? 'Hide' : 'Show',
      ],
    })
    this.props.setDiscoveryAreaOpenState(!this.props.isDiscoveryAreaOpen)
    this.setState({
      selectedSubLocality: null,
    })
  }
  clearAllAreas() {
    const { lookups } = this.props
    removeAllAreaParams()
    this.props.calculateLcaAndSelectedAreas(`${lookups.areaType}_${lookups.areaId}`)
  }

  render() {
    const {
      lcaMapTree,
      isDiscoveryAreaOpen,
      calculateLcaAndSelectedAreas,
      setDiscoveryAreaOpenState,
      lastSearchObj,
      userCurrentCity,
      setHoveredDiscoveryArea,
      googleAnalyticsEvent,
      filterByViewPort,
      selectAllChildrenArea,
      isArchive,
      pagination,
      // updateSelectedFiltersList,
      // lastSearch,
    } = this.props
    const { isDiscoveryAreaCollapsed, selectedSubLocality, localLookups } = this.state
    let currentArea = null
    let userCity = null

    if(lcaMapTree && userCurrentCity) {
      currentArea = lcaMapTree[`${userCurrentCity.areaType}_${userCurrentCity.areaId}`]
      userCity = lcaMapTree[`${userCurrentCity.areaType}_${userCurrentCity.areaId}`]
      // if there is no children in current area, hide discovery
      if(currentArea && (currentArea.children && !currentArea.children.length)) return null
      if(userCity && isBiggerThanLocality(userCity)) return null
    }
    return (
      <Fragment>
        <_Container
          data-test-id={'discoveryAreaContainer'}
          isDiscoveryAreaCollapsed={isDiscoveryAreaCollapsed}
          isDiscoveryAreaOpen={isDiscoveryAreaOpen}
        >
          {/* <TagManager */}
          {/*   updateSelectedFiltersList={updateSelectedFiltersList} */}
          {/*   lastSearch={lastSearch} */}
          {/* /> */}
          {
            !isDiscoveryAreaCollapsed && (
              <Fragment>
                <Flex justify={'between'}>
                  <_Title data-test-id={'discoverAreaTitle'}>
                    Areas in {userCity ? userCity.label : ''}
                    <_ShowAllBtn
                      textClickableBtn
                      dataTestId={'discoveryShowAllBtn'}
                      onClick={this.handleShowAllClick}
                    >
                      {isDiscoveryAreaOpen ? 'Hide' : 'Show All'}
                    </_ShowAllBtn>


                  </_Title>
                </Flex>
                {
                  isDiscoveryAreaOpen && (
                    <_AllAreaCollapsible data-test-id={'allAreaCollapsibleTab'}>
                      {renderChildrenCollapsible({
                        area: currentArea,
                        lcaMapTree,
                        lookups: localLookups,
                        calculateLcaAndSelectedAreas,
                        lastSearchObj,
                        setHoveredDiscoveryArea,
                        filterByViewPort,
                        childParentMap: this.state.childParentMap,
                        googleAnalyticsEvent,
                        selectAllChildrenArea,
                      })}
                    </_AllAreaCollapsible>
                  )
                }
                <_CollapseDiscoveryAreaBtn
                  aria-label="Toggle discover area"
                  data-test-id={'toggleDiscoverAreaBtn'}
                  textClickableBtn
                  onClick={this.discoveryAreaClose}
                >
                  <SvgIcon width={14} height={14} name={'#icon-arrow-final'} />
                </_CollapseDiscoveryAreaBtn>
                <AreaBoxListSlider
                  isDiscoveryAreaOpen={isDiscoveryAreaOpen}
                  lookups={localLookups}
                  lcaMapTree={lcaMapTree}
                  filterByViewPort={filterByViewPort}
                  setHoveredDiscoveryArea={this.props.setHoveredDiscoveryArea}
                  calculateLcaAndSelectedAreas={calculateLcaAndSelectedAreas}
                  setDiscoveryAreaOpenState={setDiscoveryAreaOpenState}
                  lastSearchObj={lastSearchObj}
                  googleAnalyticsEvent={googleAnalyticsEvent}
                  selectedSubLocality={selectedSubLocality}
                  childParentMap={this.state.childParentMap}
                  setSelectedSubLocality={this.setSelectedSubLocality}
                />
                {
                  !isDiscoveryAreaOpen && selectedSubLocality && (
                    <_AreaChildrenListContainer
                      key={selectedSubLocality.url}
                    >
                      <AreaCollapsible
                        showAllStyle
                        useDefaultStyleOnActive={false}
                        defaultActiveState
                        onOutSideClick={this.collapseOutsideClick}
                        filterByViewPort={filterByViewPort}
                        childParentMap={this.state.childParentMap}
                        lastSearchObj={lastSearchObj}
                        currentArea={selectedSubLocality}
                        calculateLcaAndSelectedAreas={calculateLcaAndSelectedAreas}
                        lcaMapTree={lcaMapTree}
                        localLookups={localLookups}
                        setHoveredDiscoveryArea={setHoveredDiscoveryArea}
                        googleAnalyticsEvent={googleAnalyticsEvent}
                        selectAllChildrenArea={selectAllChildrenArea}
                      />
                    </_AreaChildrenListContainer>
                  )
                }
              </Fragment>
            )
          }
          {
            isDiscoveryAreaCollapsed && (
              <_ShowDiscoveryAreaContainer
                center
                onClick={this.discoveryAreaOpen}
              >
                <AppButton textClickableBtn>Show Areas In {userCity ? userCity.label : ''}</AppButton>

              </_ShowDiscoveryAreaContainer>
            )
          }
        </_Container>

        {
          isDiscoveryAreaOpen && (
            <ListingCountFloatingBar
              isArchive={isArchive}
              leftButtonLabel="Clear"
              onClickLeftButton={this.clearAllAreas}
              onClickListingCountButton={this.onClickListingCountButton}
              pagination={pagination}
            />
          )
        }
      </Fragment>
    )
  }
}

DiscoveryArea.defaultProps = {
  lookups: {},
  lastSearchObj: {},
  setDiscoveryAreaOpenState: () => {},
}
DiscoveryArea.propTypes = {
  lcaMapTree: PropTypes.shape({}),
  calculateLcaAndSelectedAreas: PropTypes.func,
  setDiscoveryAreaOpenState: PropTypes.func,
  isDiscoveryAreaOpen: PropTypes.bool,
  isArchive: PropTypes.bool,
  filterByViewPort: PropTypes.string,
  lookups: PropTypes.shape({
    classType: PropTypes.string,
    areaType: PropTypes.string,
    areaId: PropTypes.number,
  }),
  lastSearchObj: PropTypes.shape({
    neighbourhood_id: PropTypes.string,
    sublocality_id: PropTypes.string,
    locality_id: PropTypes.string,
  }),
  setHoveredDiscoveryArea: PropTypes.func,
  selectAllChildrenArea: PropTypes.func,
  googleAnalyticsEvent: PropTypes.func,
  userCurrentCity: PropTypes.shape({
    areaType: PropTypes.string,
    areaId: PropTypes.number,
  }),
  pagination: PropTypes.shape({}),
  // updateSelectedFiltersList: PropTypes.func,
  // lastSearch: PropTypes.string,
}
export default DiscoveryArea
